import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/core-util/public-servant/api/bdrh/'
// const staffUrl = baseUrl + 'staff'
const staffUrl = baseUrl + 'staff_v2'

Axios.defaults.headers.timeout = 8000

export default {

  getStaff (cb) {
    Axios.get(staffUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  }
}
